import { Bar } from 'react-chartjs-2';
import { CategoryScale, LinearScale, BarElement, Chart } from 'chart.js';

Chart.register(CategoryScale, LinearScale, BarElement);

const BarChart = ({sales}) => {

    const groupAndSumByDay = (data) => {
        const groupedData = data.reduce((acc, item) => { 
            const date = new Date(item.date * 1000); 
            const formattedDate = date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' }); 
            
            if (!acc[formattedDate]) { acc[formattedDate] = 0; } 
            acc[formattedDate] += parseFloat(item.amount); return acc; 
        }, {}); 
        
        // Obtener los últimos 7 días en formato dd/mm 
        const last7Days = []; 
        const now = new Date(); 
        for (let i = 0; i < 7; i++) { 
            const pastDate = new Date(now); 
            pastDate.setDate(now.getDate() - i); 
            const formattedPastDate = pastDate.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' }); 
            if (groupedData[formattedPastDate]) { 
                last7Days.push({ date: formattedPastDate, total: groupedData[formattedPastDate] }); 
            } else { 
                last7Days.push({ date: formattedPastDate, total: 0 }); 
            } 
        } 

        return last7Days; 
    };

    const dataGrouped = groupAndSumByDay(sales);
    const labelsGroup = dataGrouped.map(e => e.date);
    const valueGroup = dataGrouped.map(e => e.total);

    const dataChart = {
        labels: labelsGroup,
        datasets: [
            {
                label: 'Ventas',
                data: valueGroup,
                backgroundColor: 'rgba(50, 100, 200, 0.5)',
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: true,
    };

    return (
        <div style={{ marginBottom: "25px" }}>
            <Bar data={dataChart} options={options} />
        </div>
    );
};

export default BarChart;